var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-section'),_c('announcements'),_c('opening-hours-section'),_c('specialization-section'),_c('equipment-section'),_c('contact-section'),_c('testimonials-section'),_c('another-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }